import { h } from "preact";
import { getText, getValue } from "../../helpers.js";

import i18n from "../../i18n";

import Button from "../Button.jsx";
import Icon from "../Icon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";

export default {
  bank_open_account_start: ({ onNext }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">Open bank account</h1>

        <div class="task-page__content">
          <p class="t-body3">Please open a bank account at the chosen bank.</p>

          <List class="mb-32">
            <ListItem number={1}>
              Follow the instructions on your bank’s website to open an account.
            </ListItem>
            <ListItem number={2}>
              Verify your ID with your passport or national ID card.
            </ListItem>
          </List>

          <List class="mb-32">
            <ListItem
              overline="Tipp"
              iconBack={
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.deutschepost.de/en/p/postident.html"
                >
                  <Icon>language</Icon>
                </a>
              }
            >
              You can either confirm your identity at your local branch via
              video chat or by going to the next post station with Postident.
            </ListItem>
          </List>

          <p class="t-body3">
            Have you successfully opened a bank account? Please pass this
            information on to Nioomi.
          </p>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
        </div>
      </section>
    );
  },
  bank_account_opened: ({ answers, onNext, onRestart }) => {
    let bankPostfix = "";
    if (getValue(answers.bank) !== "another") {
      bankPostfix = ` at ${getText(answers.bank)}`;
    }

    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem iconFront="check" overline="Bank account">
              You have successfully opened a bank account{bankPostfix}.
            </ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
          <Button outlined onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },

  bank_account_not_opened: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem iconFront="warning" overline="Bank account">
              You have not yet opened an account with a German bank.
            </ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.ok")}</Button>
          <Button outlined onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
